import type { StatusMeta } from '../types'

/**
 * Platform Standard Common Status Map (aligned with Ant Design Pro valueEnum)
 */
export const CommonStatusMap: Record<string, StatusMeta> = {
  // 1. 配置/功能开关类（统一：已启用 / 已停用 / 已生效）
  ENABLED: { text: '已启用', status: 'success' },
  DISABLED: { text: '已停用', status: 'default' },
  ACTIVE: { text: '已生效', status: 'success' },
  INACTIVE: { text: '已停用', status: 'default' },

  // 2. 运行时与流转生命周期类（统一：运行中 / 处理中 / 待处理 / 已完成 / 已失败 / 已驳回 / 已取消 / 已暂停）
  RUNNING: { text: '运行中', status: 'processing' },
  PROCESSING: { text: '处理中', status: 'processing' },
  PENDING: { text: '待处理', status: 'warning' },
  SUCCESS: { text: '已完成', status: 'success' },
  COMPLETED: { text: '已完成', status: 'success' },
  FAILED: { text: '已失败', status: 'error' },
  ERROR: { text: '异常', status: 'error' },
  REJECTED: { text: '已驳回', status: 'error' },
  APPROVED: { text: '已通过', status: 'success' },
  CANCELLED: { text: '已取消', status: 'default' },
  SUSPENDED: { text: '已暂停', status: 'warning' },

  // 3. 业务发布与上架类
  ON_SHELF: { text: '已上架', status: 'success' },
  OFF_SHELF: { text: '已下架', status: 'default' },
  PUBLISHED: { text: '已发布', status: 'success' },
  DRAFT: { text: '草稿', status: 'default' },
  DELETED: { text: '已删除', status: 'default' },
  CLOSED: { text: '已关闭', status: 'default' },

  // 4. 审核与合规判定类
  PASS: { text: '已通过', status: 'success' },
  BLOCK: { text: '已违规', status: 'error' },
  REVIEW: { text: '待审核', status: 'warning' },

  // 5. 在线可用性与服务健康度类（统一：在线 / 离线 / 就绪 / 异常）
  ONLINE: { text: '在线', status: 'success' },
  OFFLINE: { text: '离线', status: 'default' },
  READY: { text: '已就绪', status: 'success' },

  // 6. 支付与交易类
  PAID: { text: '已支付', status: 'success' },
  UNPAID: { text: '待支付', status: 'warning' }
} as const
